﻿/* KIZUNATAG editor controller.
 * Single state source. Reads window.KIZUNATAG_DATA (kizunatag-data.js) and composes
 * the preview as live SVG layers. Pet artwork uses the shared 0 0 120 108 layer set
 * and is placed into the 0 0 500 500 product canvas via DATA.petArea. pattern/fur are
 * recolored so markings never cover the features. bodyType = breed combo (からだ).
 */
(function () {
  'use strict';

  var VERSION = 'v25-status-20260608';
  var DATA = window.KIZUNATAG_DATA || {};
  var DEFAULTS = window.KIZUNATAG_DEFAULTS || {};
  var PHOTO_FEE = 1000; /* 写真から線画作成 加工費（円）: keep in sync with kizunatag-raster.js */
  var PHOTO_FEE_REGULAR = 1500;
  var PHOTO_PROMO = true;
  function photoFee(root) { var v = root && parseInt(root.dataset.photoFee, 10); return (v || v === 0) && !isNaN(v) ? v : PHOTO_FEE; }
  function photoRegularFee(root) { var v = root && parseInt(root.dataset.photoRegularFee, 10); return (v || v === 0) && !isNaN(v) ? v : PHOTO_FEE_REGULAR; }
  function photoPromo(root) { var v = root && root.dataset.photoPromo; if (v == null || v === '') return PHOTO_PROMO; return v === '1' || v === 'true'; }
  var STATE = new WeakMap();
  /* Customer-visible forbidden words. No whitelist (data-kz-allow) bypass for these. */
  var FORBIDDEN = [/メーカー/, /maker/i, /mker/i];
  var PART_CATS = DATA.partCategories || ['face', 'ears', 'eyes', 'nose', 'mouth', 'whiskers', 'pattern', 'fur', 'accessory'];
  var PATTERN_LAYERS = DATA.patternLayers || ['pattern', 'fur'];
  var PATTERN_INK = DATA.patternInk || '#cdbfae';
  var PET_ORDER = DATA.petLayerOrder || ['fur', 'face', 'ears', 'pattern', 'eyes', 'nose', 'mouth', 'whiskers', 'accessory'];

  /* ---------- asset status / environment gating ----------
   * Every pet asset carries an implicit publication status:
   *   "production" = sellable, customer-visible final artwork
   *   "prototype"  = technical placeholder (current kz-layer set), test-only
   *   "rejected"   = never shown
   * The live (production) environment shows ONLY production assets. There are
   * currently 0 production pet assets, so production renders a name-engraving
   * tag and hides the (prototype) pet customization until real artwork lands.
   * Reviewers can preview the prototype set with ?kzenv=test.
   */
  function envMode() {
    try {
      var q = new URLSearchParams(window.location.search).get('kzenv');
      if (q === 'test' || q === 'production') return q;
      if (window.localStorage && localStorage.getItem('kizunatag-env') === 'test') return 'test';
    } catch (e) { }
    return window.KIZUNATAG_ENV === 'test' ? 'test' : 'production';
  }
  var ENV = envMode();
  function assetStatus(o) { return o && o.status ? o.status : 'prototype'; }
  function publishable(o) {
    if (!o) return false;
    var s = assetStatus(o);
    if (s === 'rejected') return false;
    return ENV === 'test' ? true : s === 'production';
  }

  /* ---------- tiny helpers ---------- */
  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function sanitizeSvg(svg) {
    return String(svg || '')
      .replace(/<\s*script[\s\S]*?<\s*\/\s*script\s*>/gi, '')
      .replace(/<\s*script[\s\S]*?>/gi, '')
      .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '')
      .replace(/(href|xlink:href|src)\s*=\s*("\s*javascript:[^"]*"|'\s*javascript:[^']*')/gi, '')
      .replace(/javascript:/gi, '');
  }
  function recolorLayer(svg, layer) {
    if (PATTERN_LAYERS.indexOf(layer) > -1) {
      return String(svg).replace(/#2f2119/gi, PATTERN_INK);
    }
    return svg;
  }
  function species(root) { return root.dataset.species === 'dog' ? 'dog' : 'cat'; }
  /* When hand-drawn raster parts exist for this species, the raster controller
   * (kizunatag-raster.js) owns the root; the SVG controller stays out of the way. */
  function isRasterRoot(root) { return !!(window.KIZUNATAG_RASTER && window.KIZUNATAG_RASTER[species(root)]); }
  function speciesData(root) { return DATA[species(root)] || { presets: [], bodyTypes: [], parts: {} }; }
  function defaultsFor(root) { return DEFAULTS[species(root)] || {}; }
  function stateOf(root) { return STATE.get(root); }
  function partsList(root, cat) { return (speciesData(root).parts || {})[cat] || []; }
  function bodyTypesList(root) { return speciesData(root).bodyTypes || []; }
  function presetsList(root) { return speciesData(root).presets || []; }
  function pubPartsList(root, cat) { return partsList(root, cat).filter(publishable); }
  function pubBodyTypes(root) { return bodyTypesList(root).filter(publishable); }
  function pubPresets(root) { return presetsList(root).filter(publishable); }
  function petCustomizationEnabled(root) {
    if (pubBodyTypes(root).length || pubPresets(root).length) return true;
    for (var i = 0; i < PART_CATS.length; i++) { if (pubPartsList(root, PART_CATS[i]).length) return true; }
    return false;
  }
  /* In production with no production pet assets, strip pet state so only the
   * name-engraving tag renders; never expose prototype artwork to customers. */
  function gatePetState(root) {
    if (petCustomizationEnabled(root)) return;
    var state = stateOf(root);
    state.bodyType = ''; state.preset = null;
    PART_CATS.forEach(function (c) { state[c] = null; });
    var tabs = tabList(root);
    if (!tabs.some(function (t) { return t.key === state.active; })) state.active = tabs[0] ? tabs[0].key : 'text';
  }
  function findPart(root, cat, id) {
    var list = partsList(root, cat);
    for (var i = 0; i < list.length; i++) { if (list[i].id === id) return list[i]; }
    return list[0] || null;
  }
  function findById(coll, id) {
    var list = DATA[coll] || [];
    for (var i = 0; i < list.length; i++) { if (list[i].id === id) return list[i]; }
    return list[0] || null;
  }
  function findInList(list, id) {
    for (var i = 0; i < (list || []).length; i++) { if (list[i].id === id) return list[i]; }
    return (list && list[0]) || null;
  }
  function findPreset(root, id) { return findInList(speciesData(root).presets, id); }
  function findBodyType(root, id) {
    var list = bodyTypesList(root);
    for (var i = 0; i < list.length; i++) { if (list[i].id === id) return list[i]; }
    return null;
  }
  function material(root) { return findById('materials', stateOf(root).material) || {}; }
  function product(root) { return findById('products', stateOf(root).product) || {}; }
  function catalog() { return window.KIZUNATAG_CATALOG || {}; }
  function sizeScale(root) {
    var st = stateOf(root), C = catalog();
    var s = C.findSize ? C.findSize(st.product, st.size) : findById('sizes', st.size);
    return s && s.scale ? s.scale : 1;
  }
  function sizeSummaryLabel(root) {
    var st = stateOf(root), C = catalog();
    return C.sizeSummary ? C.sizeSummary(st.product, st.size) : ((findById('sizes', st.size) || {}).label || '');
  }
  function fontFamily(root) { var f = findById('fonts', stateOf(root).font); return f && f.family ? f.family : 'sans-serif'; }

  /* ---------- state ---------- */
  function initState(root) {
    var d = defaultsFor(root);
    var state = {
      active: 'bodyType',
      bodyType: d.bodyType || null, preset: d.preset || null,
      face: d.face || null, ears: d.ears || null, eyes: d.eyes || null,
      nose: d.nose || null, mouth: d.mouth || null, whiskers: d.whiskers || null,
      pattern: d.pattern || null, fur: d.fur || null, accessory: d.accessory || null,
      product: d.product || 'tag', material: d.material || 'wood', size: d.size || 'm', font: d.font || 'rounded',
      name: species(root) === 'dog' ? 'モコ' : 'ハナ',
      phone: '', message: 'いつも一緒だよ'
    };
    STATE.set(root, state);
    gatePetState(root);
    return state;
  }

  function applyCombo(root, apply) {
    var state = stateOf(root);
    if (!apply) return;
    PART_CATS.forEach(function (cat) {
      if (cat in apply) {
        var v = apply[cat];
        if (cat === 'whiskers' && species(root) === 'dog') { state.whiskers = null; return; }
        state[cat] = v;
      }
    });
  }
  function applyBodyType(root, id) {
    var bt = findBodyType(root, id);
    if (!bt) return;
    stateOf(root).bodyType = bt.id;
    applyCombo(root, bt.apply);
    enforceCompatibility(root);
  }
  function applyPreset(root, id) {
    var p = findPreset(root, id);
    if (!p) return;
    stateOf(root).preset = p.id;
    applyCombo(root, p.apply);
    syncBodyTypeFromParts(root);
    enforceCompatibility(root);
  }
  /* If the current parts happen to equal a known bodyType combo, highlight it. */
  function syncBodyTypeFromParts(root) {
    var state = stateOf(root);
    var list = bodyTypesList(root);
    for (var i = 0; i < list.length; i++) {
      var a = list[i].apply;
      if (a.face === state.face && a.fur === state.fur && a.pattern === state.pattern &&
        a.ears === state.ears && a.eyes === state.eyes && a.nose === state.nose && a.mouth === state.mouth) {
        state.bodyType = list[i].id; return;
      }
    }
    state.bodyType = '';
  }

  /* ---------- compatibility / fallback ---------- */
  function isCompatible(part, bodyTypeId) {
    if (!part) return false;
    var list = part.compatibleBodyTypes;
    if (!list || !list.length) return true; // empty = all compatible
    return list.indexOf(bodyTypeId) > -1;
  }
  function defaultCompatible(root, cat, bodyTypeId) {
    var list = partsList(root, cat);
    for (var i = 0; i < list.length; i++) { if (isCompatible(list[i], bodyTypeId)) return list[i].id; }
    return list[0] ? list[0].id : null;
  }
  /* Swap any part that is incompatible with the current bodyType to a safe default. */
  function enforceCompatibility(root) {
    var state = stateOf(root), bt = state.bodyType, changed = [];
    if (!bt) return changed;
    PART_CATS.forEach(function (cat) {
      if (cat === 'whiskers' && species(root) === 'dog') return;
      var id = state[cat];
      if (id == null) return;
      var part = findPart(root, cat, id);
      if (part && !isCompatible(part, bt)) {
        var def = defaultCompatible(root, cat, bt);
        if (def && def !== id) { state[cat] = def; changed.push(cat); }
      }
    });
    return changed;
  }

  function dispatch(root, action) {
    var state = stateOf(root);
    if (!state) return;
    if (action.type === 'tab') {
      state.active = action.key;
    } else if (action.type === 'select') {
      if (action.cat === 'bodyType') applyBodyType(root, action.id);
      else if (action.cat === 'preset') applyPreset(root, action.id);
      else if (action.cat === 'product' || action.cat === 'material' || action.cat === 'size' || action.cat === 'font') {
        state[action.cat] = action.id;
        if (action.cat === 'product' && catalog().normalize) catalog().normalize(state);
      }
      else if (PART_CATS.indexOf(action.cat) > -1) { state[action.cat] = action.id; syncBodyTypeFromParts(root); }
    } else if (action.type === 'input') {
      state[action.key] = String(action.value || '').slice(0, action.max || 100);
    } else if (action.type === 'reset') {
      initState(root); syncInputs(root);
    }
    render(root);
  }

  /* ---------- product canvas (0 0 500 500) ---------- */
  function plateGeom() { return { x: 58, y: 42, w: 384, h: 430, r: 46 }; }
  function roundRect(x, y, w, h, r) {
    return 'M' + (x + r) + ' ' + y + ' H' + (x + w - r) + ' Q' + (x + w) + ' ' + y + ' ' + (x + w) + ' ' + (y + r) +
      ' V' + (y + h - r) + ' Q' + (x + w) + ' ' + (y + h) + ' ' + (x + w - r) + ' ' + (y + h) +
      ' H' + (x + r) + ' Q' + x + ' ' + (y + h) + ' ' + x + ' ' + (y + h - r) +
      ' V' + (y + r) + ' Q' + x + ' ' + y + ' ' + (x + r) + ' ' + y + 'Z';
  }
  function productBaseSvg(root) {
    var g = plateGeom(), mat = material(root), prod = product(root);
    var d = roundRect(g.x, g.y, g.w, g.h, g.r);
    var ring = prod.shape && prod.shape !== 'plate'
      ? '<g><circle cx="250" cy="' + (g.y - 18) + '" r="20" fill="none" stroke="url(#kz-metal)" stroke-width="6"/></g>' : '';
    var hole = prod.hole ? '<circle cx="250" cy="' + (g.y + 30) + '" r="12" fill="#5d371f" opacity=".55"/>' : '';
    return '<g data-layer="productBase">' + ring +
      '<path d="' + d + '" fill="' + (mat.surface || '#eac58a') + '" fill-opacity="' + (mat.opacity == null ? 1 : mat.opacity) + '" stroke="' + (mat.edge || '#b98243') + '" stroke-width="4"/>' +
      '<path d="' + d + '" fill="none" stroke="#fff9ef" stroke-opacity=".30" stroke-width="2"/>' + hole + '</g>';
  }
  function materialTextureSvg() {
    var g = plateGeom();
    return '<g data-layer="materialTexture" opacity=".45"><path d="' + roundRect(g.x, g.y, g.w, g.h, g.r) + '" fill="url(#kz-sheen)"/></g>';
  }
  function cutGuideSvg() {
    var g = plateGeom(), m = 15;
    return '<g data-layer="cutGuide"><path d="' + roundRect(g.x + m, g.y + m, g.w - 2 * m, g.h - 2 * m, Math.max(8, g.r - 8)) +
      '" fill="none" stroke="#ffffff" stroke-opacity=".4" stroke-width="1.4" stroke-dasharray="6 7"/></g>';
  }

  /* ---------- pet artwork (source 0 0 120 108) ---------- */
  function partFragment(root, cat) {
    var id = stateOf(root)[cat];
    if (!id) return '';
    var p = findPart(root, cat, id);
    if (!p || !p.svg) return '';
    return '<g data-layer="' + cat + '">' + recolorLayer(sanitizeSvg(p.svg), cat) + '</g>';
  }
  function petInner(root) {
    return PET_ORDER.map(function (cat) {
      if (cat === 'whiskers' && species(root) === 'dog') return '';
      return partFragment(root, cat);
    }).join('');
  }
  function petGroupSvg(root) {
    var a = DATA.petArea || { tx: 100, ty: 85, scale: 2.5 };
    return '<g data-layer="pet" transform="translate(' + a.tx + ' ' + a.ty + ') scale(' + a.scale + ')">' + petInner(root) + '</g>';
  }
  /* Name (prominent) plus optional phone / message. Only non-empty lines are
   * rendered; the block is vertically centred in the lower plate area so the
   * preview and the laser output stay in sync with the form inputs. */
  var TEXT_BLOCK_CENTER = 410, TEXT_LINE_SPACING = 7, TEXT_MAX_WIDTH = 330;
  function textLines(root) {
    var state = stateOf(root);
    var name = state.name || (species(root) === 'dog' ? 'モコ' : 'ハナ');
    var lines = [{ t: name, size: 34, weight: 700, ls: 2 }];
    if (state.phone && String(state.phone).trim()) lines.push({ t: state.phone, size: 21, weight: 500, ls: 1 });
    if (state.message && String(state.message).trim()) lines.push({ t: state.message, size: 21, weight: 500, ls: 1 });
    var total = lines.reduce(function (s, l) { return s + l.size + TEXT_LINE_SPACING; }, 0) - TEXT_LINE_SPACING;
    var cursor = TEXT_BLOCK_CENTER - total / 2;
    lines.forEach(function (l) { l.y = cursor + l.size; cursor = l.y + TEXT_LINE_SPACING; });
    return lines;
  }
  function fitLengthAttr(l) {
    return (l.t.length * l.size > TEXT_MAX_WIDTH)
      ? ' textLength="' + TEXT_MAX_WIDTH + '" lengthAdjust="spacingAndGlyphs"' : '';
  }
  function textSvg(root) {
    var mat = material(root), ff = fontFamily(root), ink = mat.ink || '#2f2119';
    var inner = textLines(root).map(function (l) {
      return '<text x="250" y="' + l.y.toFixed(1) + '" text-anchor="middle" font-size="' + l.size + '" font-weight="' + l.weight + '" ' +
        'font-family=\'' + ff + '\' fill="' + ink + '" letter-spacing="' + l.ls + '"' + fitLengthAttr(l) +
        ' style="mix-blend-mode:' + (mat.blend || 'normal') + '" filter="url(#kz-carve)">' + esc(l.t) + '</text>';
    }).join('');
    return '<g data-layer="text">' + inner + '</g>';
  }
  function layerSvg(root, layer) {
    if (layer === 'productBase') return productBaseSvg(root);
    if (layer === 'materialTexture') return materialTextureSvg();
    if (layer === 'cutGuide') return cutGuideSvg();
    if (layer === 'pet') return petGroupSvg(root);
    if (layer === 'text') return textSvg(root);
    return '';
  }
  function defs() {
    return '<linearGradient id="kz-wood" x1="0" x2="1" y1="0" y2="1"><stop offset="0" stop-color="#f3d7a6"/><stop offset=".55" stop-color="#e8bf82"/><stop offset="1" stop-color="#d7a565"/></linearGradient>' +
      '<linearGradient id="kz-acrylic" x1="0" x2="1"><stop offset="0" stop-color="#ffffff" stop-opacity=".58"/><stop offset=".55" stop-color="#f4fbfb" stop-opacity=".34"/><stop offset="1" stop-color="#d6ecef" stop-opacity=".62"/></linearGradient>' +
      '<linearGradient id="kz-leather" x1="0" x2="1" y1="0" y2="1"><stop offset="0" stop-color="#b87549"/><stop offset=".55" stop-color="#8d4f2c"/><stop offset="1" stop-color="#6b351d"/></linearGradient>' +
      '<linearGradient id="kz-metal" x1="0" x2="1"><stop offset="0" stop-color="#f8f8f6"/><stop offset=".25" stop-color="#b9b7b1"/><stop offset=".55" stop-color="#ffffff"/><stop offset="1" stop-color="#8d8a84"/></linearGradient>' +
      '<radialGradient id="kz-sheen" cx=".4" cy=".3" r=".9"><stop offset="0" stop-color="#ffffff" stop-opacity=".55"/><stop offset="1" stop-color="#ffffff" stop-opacity="0"/></radialGradient>' +
      '<filter id="kz-carve"><feDropShadow dx="0" dy="1.1" stdDeviation=".4" flood-color="#fff8ea" flood-opacity=".3"/><feDropShadow dx="0" dy="-1.1" stdDeviation=".4" flood-color="#1f140d" flood-opacity=".28"/></filter>' +
      '<filter id="kz-product-shadow"><feDropShadow dx="0" dy="12" stdDeviation="9" flood-color="#5f3d24" flood-opacity=".22"/></filter>';
  }
  function buildPreviewInner(root) {
    var sc = sizeScale(root);
    var inner = (DATA.layerOrder || []).map(function (l) { return layerSvg(root, l); }).join('');
    return '<defs>' + defs() + '</defs>' +
      '<g filter="url(#kz-product-shadow)" transform="translate(250 250) scale(' + sc + ') translate(-250 -250)">' + inner + '</g>';
  }

  /* ---------- production SVG (laser) ---------- */
  function stripProductionUnsafe(svg) {
    return sanitizeSvg(svg)
      .replace(/\sfilter\s*=\s*("[^"]*"|'[^']*')/gi, '')
      .replace(/\sstyle\s*=\s*("[^"]*"|'[^']*')/gi, '')
      .replace(/<\s*image[\s\S]*?>/gi, '')
      .replace(/url\(\s*#[^)]*\)/gi, 'none');
  }
  function productionCutSvg() {
    var g = plateGeom();
    return '<g id="cut" fill="none" stroke="#ff0000" stroke-width="1"><path d="' + roundRect(g.x, g.y, g.w, g.h, g.r) + '"/></g>';
  }
  function productionEngraveSvg(root) {
    var a = DATA.petArea || { tx: 100, ty: 85, scale: 2.5 };
    var inner = PET_ORDER.map(function (cat) {
      if (cat === 'whiskers' && species(root) === 'dog') return '';
      var id = stateOf(root)[cat]; if (!id) return '';
      var p = findPart(root, cat, id); if (!p || !p.svg) return '';
      return recolorLayer(sanitizeSvg(p.svg), cat);
    }).join('');
    return '<g id="engrave" transform="translate(' + a.tx + ' ' + a.ty + ') scale(' + a.scale + ')">' + stripProductionUnsafe(inner) + '</g>';
  }
  function productionTextSvg(root) {
    var ff = fontFamily(root);
    var inner = textLines(root).map(function (l) {
      return '<text x="250" y="' + l.y.toFixed(1) + '" text-anchor="middle" font-size="' + l.size + '" font-weight="' + l.weight + '" ' +
        'font-family=\'' + ff + '\' fill="#1a1a1a" letter-spacing="' + l.ls + '"' + fitLengthAttr(l) + '>' + esc(l.t) + '</text>';
    }).join('');
    return '<g id="text">' + inner + '</g>';
  }
  function buildProductionSvg(root) {
    var vb = (DATA.canvas && DATA.canvas.viewBox) || '0 0 500 500';
    var meta = '<metadata id="metadata">' + esc(JSON.stringify(designData(root))) + '</metadata>';
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="' + vb + '">' +
      meta + productionCutSvg() + productionEngraveSvg(root) + productionTextSvg(root) + '</svg>';
  }
  function safeProductionSvgProperty(root) {
    var svg = buildProductionSvg(root);
    if (!svg || svg.length > 6000) { return { '_production_svg_status': 'too_large_generate_from_design_data' }; }
    return { '_production_svg': svg };
  }

  /* ---------- UI rendering ---------- */
  function tabList(root) {
    var cats = DATA.categories || [];
    return cats.filter(function (c) {
      if (c.key === 'product') return false;
      if (c.key === 'text') return true;
      if (c.key === 'preset') return pubPresets(root).length > 0;
      if (c.key === 'bodyType') return pubBodyTypes(root).length > 0;
      if (c.key === 'noseMouth') return pubPartsList(root, 'nose').length > 0 || pubPartsList(root, 'mouth').length > 0;
      return PART_CATS.indexOf(c.key) > -1 && pubPartsList(root, c.key).length > 0;
    });
  }
  function catLabel(key) {
    var cats = DATA.categories || [];
    for (var i = 0; i < cats.length; i++) { if (cats[i].key === key) return cats[i].label; }
    return key;
  }
  function bodyTypeLabel(root) {
    var b = findBodyType(root, stateOf(root).bodyType);
    return b ? b.label : 'カスタム';
  }
  function presetLabel(root) {
    var p = findPreset(root, stateOf(root).preset);
    return p ? p.label : 'カスタム';
  }
  function selectedLabel(root, key) {
    if (key === 'preset') return presetLabel(root);
    if (key === 'bodyType') return bodyTypeLabel(root);
    if (key === 'text') return stateOf(root).name || '';
    if (key === 'noseMouth') {
      var n = findPart(root, 'nose', stateOf(root).nose), m = findPart(root, 'mouth', stateOf(root).mouth);
      return (n ? n.label : 'なし') + '・' + (m ? m.label : 'なし');
    }
    var p = findPart(root, key, stateOf(root)[key]);
    return p ? p.label : 'なし';
  }

  function render(root) {
    enforceCompatibility(root);
    var tabs = tabList(root), state = stateOf(root);
    if (!tabs.some(function (t) { return t.key === state.active; })) state.active = tabs[0] ? tabs[0].key : 'text';
    renderTabs(root); renderPanel(root); renderParts(root);
    renderOptions(root); renderPreview(root); renderSummary(root); syncOrderData(root);
  }
  function renderTabs(root) {
    var state = stateOf(root);
    var html = tabList(root).map(function (c) {
      return '<button class="kz-tab' + (c.key === state.active ? ' active' : '') + '" type="button" aria-pressed="' + (c.key === state.active ? 'true' : 'false') + '" aria-label="' + esc(c.label) + '" data-kz-tab="' + c.key + '">' +
        '<span class="kz-tab-mark ' + c.key + '" aria-hidden="true"></span>' + esc(c.label) + '</button>';
    }).join('');
    $$(root, '[data-kz-tabs]').forEach(function (el) { el.innerHTML = html; });
  }
  function renderPanel(root) {
    var state = stateOf(root);
    $$(root, '[data-kz-panel-title]').forEach(function (el) { el.textContent = catLabel(state.active) + 'を選ぶ'; });
    $$(root, '[data-kz-selected-label]').forEach(function (el) { el.textContent = selectedLabel(root, state.active); });
  }
  function faceGuide() {
    return '<ellipse cx="60" cy="56" rx="44" ry="44" fill="#fbf3e7" stroke="#e7d6c0" stroke-width="2"/>';
  }
  function thumbWrap(inner) {
    return '<svg class="kz-thumb-svg" viewBox="0 0 120 108" aria-hidden="true">' + inner + '</svg>';
  }
  function comboThumb(root, apply) {
    var inner = PET_ORDER.map(function (cat) {
      if (cat === 'whiskers' && species(root) === 'dog') return '';
      var id = apply[cat]; if (!id) return '';
      var p = findPart(root, cat, id); if (!p || !p.svg) return '';
      return recolorLayer(sanitizeSvg(p.svg), cat);
    }).join('');
    return thumbWrap(inner);
  }
  function partThumb(root, cat, p) {
    if (!p.svg) return '<span class="kz-thumb-svg kz-thumb-none">なし</span>';
    var guide = (cat === 'face' || cat === 'fur') ? '' : faceGuide();
    return thumbWrap(guide + recolorLayer(sanitizeSvg(p.svg), cat));
  }
  function choiceButton(cat, id, art, label, active) {
    return '<button class="kz-part' + (active ? ' active' : '') + '" type="button" aria-pressed="' + (active ? 'true' : 'false') + '" aria-label="' + esc(label) + '" data-kz-select data-cat="' + cat + '" data-id="' + esc(id) + '">' +
      art + '<span>' + esc(label) + '</span></button>';
  }
  var PREPARING_NOTE = '<div class="kz-part-note">ただいま、こちらのデザインパーツを準備中です。お名前の刻印はそのままご利用いただけます。</div>';
  function renderParts(root) {
    var state = stateOf(root), key = state.active, html;
    if (key === 'text') {
      html = '<div class="kz-part-note">下のフォームに、お名前・電話番号・メッセージを入力してください。入力するとプレビューにすぐ反映されます。</div>';
    } else if (key === 'preset') {
      var ps = pubPresets(root);
      html = ps.length ? ps.map(function (p) {
        return choiceButton('preset', p.id, comboThumb(root, p.apply), p.label, state.preset === p.id);
      }).join('') : PREPARING_NOTE;
    } else if (key === 'bodyType') {
      var bs = pubBodyTypes(root);
      html = bs.length ? bs.map(function (b) {
        return choiceButton('bodyType', b.id, comboThumb(root, b.apply), b.label, state.bodyType === b.id);
      }).join('') : PREPARING_NOTE;
    } else if (key === 'noseMouth') {
      var noses = pubPartsList(root, 'nose'), mouths = pubPartsList(root, 'mouth');
      html = (noses.length || mouths.length)
        ? '<div class="kz-subgroup"><h4 class="kz-subgroup-title">お鼻</h4><div class="kz-subgroup-grid">' +
          noses.map(function (p) { return choiceButton('nose', p.id, partThumb(root, 'nose', p), p.label, state.nose === p.id); }).join('') +
          '</div></div><div class="kz-subgroup"><h4 class="kz-subgroup-title">お口</h4><div class="kz-subgroup-grid">' +
          mouths.map(function (p) { return choiceButton('mouth', p.id, partThumb(root, 'mouth', p), p.label, state.mouth === p.id); }).join('') +
          '</div></div>'
        : PREPARING_NOTE;
    } else {
      var ls = pubPartsList(root, key);
      html = ls.length ? ls.map(function (p) {
        return choiceButton(key, p.id, partThumb(root, key, p), p.label, state[key] === p.id);
      }).join('') : PREPARING_NOTE;
    }
    $$(root, '[data-kz-parts]').forEach(function (el) { el.innerHTML = html; });
  }

  function renderOptions(root) {
    var state = stateOf(root), C = catalog();
    if (C.normalize) C.normalize(state);
    fillOptions(root, 'product', DATA.products || [], state.product, productThumb);
    fillOptions(root, 'material', C.materialsFor ? C.materialsFor(state.product) : (DATA.materials || []), state.material, materialThumb);
    fillOptions(root, 'size', C.sizesFor ? C.sizesFor(state.product) : (DATA.sizes || []), state.size, sizeThumb, sizeChoiceLabel);
  }
  function fillOptions(root, cat, items, current, art, labelFn) {
    var html = items.map(function (item, i) {
      var label = labelFn ? labelFn(item) : '<span>' + esc(item.label) + '</span>';
      return '<button class="kz-choice' + (item.id === current ? ' active' : '') + '" type="button" aria-pressed="' + (item.id === current ? 'true' : 'false') + '" aria-label="' + esc(item.label || item.name || '') + '" data-kz-select data-cat="' + cat + '" data-id="' + esc(item.id) + '">' +
        art(item, i, items.length) + label + '</button>';
    }).join('');
    $$(root, '[data-kz-options="' + cat + '"]').forEach(function (el) { el.innerHTML = html; });
  }
  function sizeChoiceLabel(item) {
    return '<span class="kz-size-label"><span class="kz-size-name">' + esc(item.name) + '</span>' +
      '<span class="kz-size-mm">' + esc(item.mm) + '</span></span>';
  }
  function productThumb(prod) {
    return '<span class="kz-choice-art" aria-hidden="true"><svg class="kz-choice-svg" viewBox="0 0 80 80" aria-hidden="true" focusable="false"><rect x="16" y="12" width="48" height="56" rx="12" fill="#f0d9b0" stroke="#c69a67" stroke-width="3"/>' +
      (prod.hole ? '<circle cx="40" cy="22" r="4" fill="#fff" stroke="#c69a67" stroke-width="2"/>' : '') + '</svg></span>';
  }
  function materialThumb(mat) { return '<span class="kz-material-swatch" aria-hidden="true" style="background:' + (mat.swatch || '#e6bd82') + '"></span>'; }
  function sizeThumb(i, total) {
    var n = total || 3;
    var rs = n <= 1 ? [18] : [12, 16, 21];
    var r = rs[Math.min(i, rs.length - 1)] || 16;
    return '<span class="kz-choice-art" aria-hidden="true"><svg class="kz-choice-svg" viewBox="0 0 80 64" aria-hidden="true" focusable="false"><circle cx="40" cy="32" r="' + r + '" fill="#f5dfb8" stroke="#c69a67" stroke-width="3"/></svg></span>';
  }
  function renderPreview(root) {
    var svg = buildPreviewInner(root);
    // Each preview SVG must own unique defs ids; duplicate ids across the desktop
    // and mobile preview cause url(#..) refs to resolve into a display:none subtree
    // (which prevents the filtered group from painting). Suffix ids per element.
    $$(root, '[data-kz-preview]').forEach(function (el, i) {
      el.innerHTML = i === 0 ? svg : svg.replace(/kz-(wood|acrylic|leather|metal|sheen|carve|product-shadow)/g, 'kz-$1-' + i);
    });
  }
  function renderSummary(root) {
    var state = stateOf(root);
    var L = function (cat) { if (!state[cat]) return 'なし'; var p = findPart(root, cat, state[cat]); return p ? p.label : 'なし'; };
    var rows = [];
    if (petCustomizationEnabled(root)) {
      rows.push(['からだ', bodyTypeLabel(root)]);
      rows.push(['お鼻・お口', L('nose') + '・' + L('mouth')]);
    }
    rows.push(['商品', (findById('products', state.product) || {}).label]);
    rows.push(['素材', (findById('materials', state.material) || {}).label]);
    rows.push(['サイズ', sizeSummaryLabel(root)]);
    rows.push(['お名前', state.name || '']);
    var html = '<b>ご注文内容</b><br>' + rows.map(function (r) { return esc(r[0]) + '：' + esc(r[1]); }).join('<br>') +
      '<small>実際の刻印では、素材に合わせて線の太さや濃淡を調整して制作します。</small>';
    $$(root, '[data-kz-summary]').forEach(function (el) { el.innerHTML = html; });
    var prefix = root.dataset.productPrefix || species(root);
    var products = DATA.products || [], idx = 0;
    for (var i = 0; i < products.length; i++) { if (products[i].id === state.product) { idx = i; break; } }
    $$(root, '[data-kz-finish-image]').forEach(function (img) { img.src = assetUrl(prefix + '-product-' + (idx + 1) + '.jpg'); });
  }
  function assetUrl(file) {
    var probe = document.querySelector('script[src*="kizunatag-maker.js"]');
    var src = (probe && probe.src) || '';
    var base = src.indexOf('/assets/') > -1 ? src.split('/assets/')[0] + '/assets/' : '';
    return base + file;
  }

  /* ---------- order data ---------- */
  function designData(root) {
    var state = stateOf(root);
    return {
      version: VERSION, species: species(root),
      bodyType: state.bodyType,
      parts: {
        face: state.face, ears: state.ears, eyes: state.eyes, nose: state.nose, mouth: state.mouth,
        whiskers: state.whiskers, pattern: state.pattern, fur: state.fur, accessory: state.accessory
      },
      preset: state.preset, product: state.product, material: state.material, size: state.size, font: state.font,
      text: { name: state.name, phone: state.phone, message: state.message },
      faceMode: 'preset', photoOptionEnabled: false, photoOptionFee: photoFee(root),
      photoOptionRegularFee: photoRegularFee(root), photoOptionPromo: photoPromo(root),
      uploadedPhotoName: null, engravingDifferenceAccepted: false
    };
  }
  function orderProperties(root) {
    var state = stateOf(root);
    var L = function (cat) { if (!state[cat]) return 'なし'; var p = findPart(root, cat, state[cat]); return p ? p.label : 'なし'; };
    var props = { 'うちの子': species(root) === 'dog' ? 'わんちゃん' : '猫ちゃん' };
    if (petCustomizationEnabled(root)) {
      props['からだ'] = bodyTypeLabel(root);
      props['お顔'] = L('face'); props['お耳'] = L('ears'); props['おめめ'] = L('eyes');
      props['お鼻'] = L('nose'); props['お口'] = L('mouth');
      props['模様'] = L('pattern'); props['毛なみ'] = L('fur'); props['飾り'] = L('accessory');
    }
    props['写真作成オプション'] = 'なし';
    props['商品'] = (findById('products', state.product) || {}).label || '';
    props['素材'] = (findById('materials', state.material) || {}).label || '';
    props['サイズ'] = sizeSummaryLabel(root);
    props['お名前'] = state.name || ''; props['電話番号'] = state.phone || ''; props['メッセージ'] = state.message || '';
    props['_design_data'] = JSON.stringify(designData(root));
    var svgProp = safeProductionSvgProperty(root);
    Object.keys(svgProp).forEach(function (k) { props[k] = svgProp[k]; });
    if (species(root) !== 'dog') props['おひげ'] = L('whiskers');
    return props;
  }
  function syncOrderData(root) { root.dataset.kzOrderProperties = JSON.stringify(orderProperties(root)); }

  async function addToCart(root) {
    var state = stateOf(root);
    if (!state.name || !state.name.trim()) {
      alert('お名前を入力してください');
      if (state.active !== 'text') dispatch(root, { type: 'tab', key: 'text' });
      var nameInput = root.querySelector('[data-kz-input="name"]');
      if (nameInput) nameInput.focus();
      return;
    }
    var id = root.dataset.variantId;
    if (!id) { alert('ただいま商品の準備中です。お手数ですが、少し時間をおいてもう一度お試しください。'); return; }
    var props = orderProperties(root);
    var fd = new FormData();
    fd.append('id', String(Number(id)));
    fd.append('quantity', '1');
    Object.keys(props).forEach(function (k) { fd.append('properties[' + k + ']', props[k]); });
    var res = await fetch('/cart/add.js', { method: 'POST', body: fd });
    if (!res.ok) throw new Error('cart add failed');
    window.location.href = '/cart';
  }
  function downloadPng(root) {
    var el = $(root, '[data-kz-preview]');
    if (!el) return;
    var svg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 500">' + el.innerHTML + '</svg>';
    var url = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
    var img = new Image();
    img.onload = function () {
      var canvas = document.createElement('canvas'); canvas.width = 1000; canvas.height = 1000;
      var ctx = canvas.getContext('2d'); ctx.fillStyle = '#fbf7ef'; ctx.fillRect(0, 0, 1000, 1000); ctx.drawImage(img, 0, 0, 1000, 1000);
      URL.revokeObjectURL(url);
      var a = document.createElement('a'); a.href = canvas.toDataURL('image/png'); a.download = 'kizunatag-design.png'; a.click();
    };
    img.src = url;
  }

  /* ---------- inputs / storage ---------- */
  function syncInputs(root) {
    var state = stateOf(root);
    [['name', state.name], ['phone', state.phone], ['message', state.message]].forEach(function (pair) {
      $$(root, '[data-kz-input="' + pair[0] + '"]').forEach(function (el) { el.value = pair[1] || ''; });
    });
  }
  function storageKey(root) { return 'kizunatag-' + VERSION + '-' + species(root); }
  function saveState(root) { try { localStorage.setItem(storageKey(root), JSON.stringify(stateOf(root))); } catch (e) { } }
  function restoreState(root) {
    try {
      var raw = localStorage.getItem(storageKey(root));
      if (raw) {
        var saved = JSON.parse(raw), state = stateOf(root);
        Object.keys(saved).forEach(function (k) { if (k in state) state[k] = saved[k]; });
      }
    } catch (e) { }
  }

  /* ---------- events ---------- */
  function bindDelegates() {
    document.addEventListener('click', function (event) {
      var root = event.target.closest('[data-kz-maker]');
      if (!root || isRasterRoot(root)) return;
      var el = event.target.closest('[data-kz-tab],[data-kz-select],[data-kz-save],[data-kz-png],[data-kz-cart],[data-kz-reset]');
      if (!el || !root.contains(el)) return;
      if (el.hasAttribute('data-kz-tab')) { dispatch(root, { type: 'tab', key: el.getAttribute('data-kz-tab') }); return; }
      if (el.hasAttribute('data-kz-select')) { dispatch(root, { type: 'select', cat: el.getAttribute('data-cat'), id: el.getAttribute('data-id') }); return; }
      if (el.hasAttribute('data-kz-save')) { saveState(root); flash(el, '保存しました'); return; }
      if (el.hasAttribute('data-kz-reset')) { dispatch(root, { type: 'reset' }); return; }
      if (el.hasAttribute('data-kz-png')) { downloadPng(root); return; }
      if (el.hasAttribute('data-kz-cart')) { addToCart(root).catch(function () { alert('カートに追加できませんでした。入力内容をご確認のうえ、もう一度お試しください。'); }); return; }
    });
    document.addEventListener('input', function (event) {
      var root = event.target.closest('[data-kz-maker]');
      if (!root || isRasterRoot(root)) return;
      var el = event.target, key = el.getAttribute && el.getAttribute('data-kz-input');
      if (!key) return;
      var max = key === 'name' ? 10 : key === 'phone' ? 15 : 24;
      dispatch(root, { type: 'input', key: key, value: el.value, max: max });
    });
  }
  function flash(el, msg) { var old = el.textContent; el.textContent = msg; setTimeout(function () { el.textContent = old; }, 1400); }

  function init(root) {
    if (isRasterRoot(root)) return;
    initState(root); restoreState(root);
    if (catalog().normalize) catalog().normalize(stateOf(root));
    gatePetState(root); syncInputs(root); render(root);
  }

  function setupHomepageSwitch() {
    var params = new URLSearchParams(window.location.search);
    var maker = params.get('maker');
    var home = document.querySelector('[data-kz-home]');
    var makers = document.querySelectorAll('.kz-homepage-maker');
    if (!makers.length) return;
    Array.prototype.forEach.call(makers, function (m) { m.classList.remove('is-active'); });
    if (maker === 'cat' || maker === 'dog') {
      if (home) home.classList.add('is-hidden');
      Array.prototype.forEach.call(makers, function (m) { if (m.dataset.species === maker) m.classList.add('is-active'); });
      window.scrollTo(0, 0);
    } else if (home) { home.classList.remove('is-hidden'); }
  }

  /* ---------- anti-glitch validation ---------- */
  function validateCurrentCombination(root) {
    var state = stateOf(root), issues = [], fixed = [];
    var preview = buildPreviewInner(root);
    if (/undefined|null|\[object Object\]/.test(preview)) issues.push('preview_has_placeholder_token');
    if (/<script|on\w+=|javascript:/i.test(preview)) issues.push('preview_unsafe');
    PART_CATS.forEach(function (cat) {
      if (cat === 'whiskers' && species(root) === 'dog') return;
      var id = state[cat];
      var optional = (cat === 'pattern' || cat === 'accessory' || cat === 'whiskers');
      if (id == null) { if (!optional) issues.push(cat + ':null'); return; }
      var p = findPart(root, cat, id);
      if (!p) { issues.push(cat + ':missing(' + id + ')'); state[cat] = defaultCompatible(root, cat, state.bodyType); fixed.push(cat); return; }
      if (p.id !== id) { issues.push(cat + ':id_mismatch'); }
      if (!optional && !p.svg) { issues.push(cat + ':empty_svg'); }
      if (p.svg && /<script|on\w+=|javascript:/i.test(p.svg)) { issues.push(cat + ':unsafe_svg'); }
      if (state.bodyType && !isCompatible(p, state.bodyType)) {
        var def = defaultCompatible(root, cat, state.bodyType);
        if (def) { state[cat] = def; fixed.push(cat); issues.push(cat + ':incompatible->fallback'); }
      }
    });
    PART_CATS.forEach(function (cat) {
      if (cat === 'whiskers' && species(root) === 'dog') return;
      if (!partsList(root, cat).length) issues.push(cat + ':no_options');
    });
    if (fixed.length) render(root);
    return { ok: issues.length === 0, issues: issues, fixed: fixed };
  }

  function runVisualCombinationAudit(root) {
    root = root || document.querySelector('[data-kz-maker]');
    if (!root) return { ok: false, rows: [], note: 'no_root' };
    var rows = [];
    var snapshot = JSON.stringify(stateOf(root));
    function check(bt, category, optionId) {
      var v = validateCurrentCombination(root);
      rows.push({ bodyType: bt, category: category, optionId: optionId, result: v.ok ? 'PASS' : 'FAIL', reason: v.issues.join(',') });
      return v.ok;
    }
    // 1) each bodyType default combo
    bodyTypesList(root).forEach(function (b) {
      dispatch(root, { type: 'select', cat: 'bodyType', id: b.id });
      check(b.id, 'bodyType', b.id);
    });
    // 2) each category, switch through every option once (on current bodyType)
    var bt = stateOf(root).bodyType;
    var cats = ['pattern', 'eyes', 'ears', 'nose', 'mouth', 'fur', 'accessory'];
    if (species(root) === 'cat') cats.push('whiskers');
    cats.forEach(function (cat) {
      partsList(root, cat).forEach(function (p) {
        dispatch(root, { type: 'select', cat: cat, id: p.id });
        check(bt, cat, p.id);
      });
    });
    // 3) product / material / size / text
    (DATA.products || []).forEach(function (p) { dispatch(root, { type: 'select', cat: 'product', id: p.id }); check(bt, 'product', p.id); });
    (DATA.materials || []).forEach(function (m) { dispatch(root, { type: 'select', cat: 'material', id: m.id }); check(bt, 'material', m.id); });
    (DATA.sizes || []).forEach(function (s) { dispatch(root, { type: 'select', cat: 'size', id: s.id }); check(bt, 'size', s.id); });
    dispatch(root, { type: 'input', key: 'name', value: 'テスト犬', max: 10 }); check(bt, 'text', 'name');
    // restore
    try { var saved = JSON.parse(snapshot); var st = stateOf(root); Object.keys(saved).forEach(function (k) { st[k] = saved[k]; }); render(root); } catch (e) { }
    var fails = rows.filter(function (r) { return r.result === 'FAIL'; });
    if (typeof console !== 'undefined' && console.table) { console.table(rows); }
    return { ok: fails.length === 0, total: rows.length, fails: fails.length, rows: rows };
  }

  /* ---------- self tests ---------- */
  function assertNoForbiddenVisibleText(scope) {
    scope = scope || document.body;
    var hits = [];
    var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var p = node.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        if (p.closest('script,style,template,[hidden],[type="hidden"]')) return NodeFilter.FILTER_REJECT;
        var cs = window.getComputedStyle(p);
        if (cs && (cs.display === 'none' || cs.visibility === 'hidden')) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var node;
    while ((node = walker.nextNode())) {
      var t = node.nodeValue || '';
      FORBIDDEN.forEach(function (re) { if (re.test(t)) hits.push(t.trim().slice(0, 40)); });
    }
    return { ok: hits.length === 0, hits: hits };
  }

  function runKizunatagSelfTest(root) {
    root = root || document.querySelector('[data-kz-maker]');
    var results = [];
    var add = function (name, ok, detail) { results.push({ name: name, ok: !!ok, detail: detail || '' }); };
    try {
      add('1 ページが開ける', !!document.querySelector('[data-kz-maker]'));
      add('単一データ源 (KIZUNATAG_DATA)', !!(DATA && DATA.layerOrder && DATA.canvas));
      add('canvas viewBox 500', (DATA.canvas || {}).viewBox === '0 0 500 500');
      add('bodyType 犬15', (DATA.dog.bodyTypes || []).length >= 15);
      add('bodyType 猫12', (DATA.cat.bodyTypes || []).length >= 12);
      if (root) {
        var state = stateOf(root);
        add('状態が単一', !!state && STATE.get(root) === state);
        add('2 犬猫の既定値あり', !!(DEFAULTS.dog && DEFAULTS.cat));
        add('3 分類タブが描画される', root.querySelectorAll('[data-kz-tab]').length > 6);
        var before = buildProductionSvg(root);
        var eyesList = partsList(root, 'eyes');
        if (eyesList.length > 1) {
          var other = eyesList.find(function (p) { return p.id !== state.eyes; });
          if (other) dispatch(root, { type: 'select', cat: 'eyes', id: other.id });
        }
        add('4 部件切替でプレビュー更新', before !== buildProductionSvg(root));
        var inner = buildPreviewInner(root);
        add('5 プレビュー安定 (pet+face)', /data-layer="pet"/.test(inner) && /data-layer="face"/.test(inner));
        add('図層順: face<eyes', inner.indexOf('data-layer="face"') < inner.indexOf('data-layer="eyes"'));
        add('図層順: pattern<eyes', inner.indexOf('data-layer="pattern"') < inner.indexOf('data-layer="eyes"'));
        var p0 = buildPreviewInner(root);
        dispatch(root, { type: 'select', cat: 'material', id: 'leather' });
        add('6 素材連動', p0 !== buildPreviewInner(root));
        dispatch(root, { type: 'select', cat: 'size', id: 'l' });
        add('6 サイズ連動', /scale\(1.08\)/.test(buildPreviewInner(root)));
        dispatch(root, { type: 'input', key: 'name', value: 'テスト', max: 10 });
        add('7 文字連動', buildProductionSvg(root).indexOf('テスト') > -1);
        // bodyType switch changes preview + parts
        var b0 = buildPreviewInner(root);
        var bts = bodyTypesList(root);
        var ob = bts.find(function (b) { return b.id !== state.bodyType; });
        if (ob) dispatch(root, { type: 'select', cat: 'bodyType', id: ob.id });
        add('bodyType 切替でプレビュー更新', b0 !== buildPreviewInner(root));
        add('8 加購関数あり', typeof addToCart === 'function');
        add('8 variant id 状態管理', 'variantId' in root.dataset);
        var props = orderProperties(root);
        add('9 properties 完整', props['商品'] && props['素材'] && props['サイズ'] && props['からだ'] && props['お名前'] != null);
        add('10 隠しフィールド _design_data', '_design_data' in props && ('_production_svg' in props || '_production_svg_status' in props));
        add('10 隠し命名規則 (_先頭)', Object.keys(props).filter(function (k) { return k.charAt(0) === '_'; }).length >= 2);
        var psvg = buildProductionSvg(root);
        add('D viewBox 500', /viewBox="0 0 500 500"/.test(psvg));
        add('D filterなし', !/filter/i.test(psvg));
        add('D gradientなし', !/gradient|url\(#/i.test(psvg));
        add('D imageなし/base64なし', !/<image|base64|xlink:href|\.png|\.jpg/i.test(psvg));
        add('D scriptなし', !/<script|on\w+=/i.test(psvg));
        add('D group cut/engrave/text/metadata', /id="cut"/.test(psvg) && /id="engrave"/.test(psvg) && /id="text"/.test(psvg) && /id="metadata"/.test(psvg));
        add('D 影/blendなし', !/feDropShadow|drop-shadow|mix-blend/i.test(psvg));
        add('11 モバイルUIあり', !!root.querySelector('.kz-mobile-ui'));
        var f = assertNoForbiddenVisibleText(document.body);
        add('12 前台に禁止語なし', f.ok, f.hits.join(' | '));
        add('13 Instagram 区块', !!document.querySelector('[data-kz-instagram]'));
        add('SVG sanitize', sanitizeSvg('<g onload="x()"><script>bad()<\/script><a href="javascript:1"/></g>').indexOf('onload') === -1);
        // combination audit
        var audit = runVisualCombinationAudit(root);
        add('組合審計 PASS (' + audit.total + '件)', audit.ok, audit.fails + ' fails');
        var vc = validateCurrentCombination(root);
        add('現在組合 健全', vc.ok, vc.issues.join(','));
      }
    } catch (e) {
      add('例外なし', false, e.message);
    }
    var ok = results.every(function (r) { return r.ok; });
    if (root) { initState(root); restoreState(root); syncInputs(root); render(root); }
    return { ok: ok, version: VERSION, results: results };
  }

  window.runKizunatagSelfTest = runKizunatagSelfTest;
  window.runVisualCombinationAudit = runVisualCombinationAudit;
  window.validateCurrentCombination = validateCurrentCombination;
  window.assertNoForbiddenVisibleText = assertNoForbiddenVisibleText;
  window.__KIZUNATAG__ = { init: init, dispatch: dispatch, buildPreviewInner: buildPreviewInner, buildProductionSvg: buildProductionSvg, orderProperties: orderProperties, stateOf: stateOf };

  document.addEventListener('DOMContentLoaded', function () {
    bindDelegates();
    document.querySelectorAll('[data-kz-maker]').forEach(init);
    setupHomepageSwitch();
  });
})();
